import { nanoid } from 'nanoid';
import { useQueryState } from 'nuqs';
import { useEffect } from 'react';

import { type QueryStateSchema, backwardsCompatabilityFactory, queryParam, queryStateParser } from './queryStateParser';

const QS_KEY = 'paneUserWorkflowId';
const QS_TYPE: QueryStateSchema['type'] = 'pacerPreview';

export const useOpenPacerPreviewPane = (): ((args: { userWorkflowId: string; skeleton?: boolean }) => void) => {
  const [userWorkflowIdDeprecated, setUserWorkflowId] = useQueryState(QS_KEY);
  const [__, setState] = useQueryState(queryParam, queryStateParser);

  useEffect(() => {
    if (userWorkflowIdDeprecated) {
      setUserWorkflowId(null);
      setState(backwardsCompatabilityFactory({ id: userWorkflowIdDeprecated, type: QS_TYPE }));
    }
  }, [userWorkflowIdDeprecated]);

  return ({ userWorkflowId, skeleton }) => {
    setState((prevState) => [
      ...(prevState || []),
      {
        id: userWorkflowId,
        key: nanoid(),
        skeleton: skeleton || undefined,
        type: QS_TYPE,
      },
    ]);
  };
};
